export const skinToTypographyMap = {
  default: 'secondary',
  error: 'error',
  success: 'success',
  warning: 'warning',
  primary: 'primary'
};